import { createFileRoute, redirect } from "@tanstack/react-router";

// Canonical Policy Library now lives at /app/policies. This redirect
// preserves any existing bookmarks or links to /app/policies/library.
export const Route = createFileRoute("/_authenticated/app/policies/library")({
  beforeLoad: () => {
    throw redirect({ to: "/app/policies", replace: true });
  },
  component: () => null,
});
